import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from 'react-router-dom';
import { resetState } from "../../store";
import { API_LOGOUT } from "../../settings";

const LogoutPage = ({ location }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        fetch(API_LOGOUT, {});
        dispatch(resetState());
    }, []);

    return (
        <Redirect push to={`/login${location.search}`} />
    )
};

export { LogoutPage };